import { render, staticRenderFns } from "./CoursesSortModal.vue?vue&type=template&id=36195fcd&scoped=true&"
import script from "./CoursesSortModal.vue?vue&type=script&lang=ts&"
export * from "./CoursesSortModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesSortModal.vue?vue&type=style&index=0&id=36195fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36195fcd",
  null
  
)

export default component.exports